import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BID_CLOSE_MONITOR_SETTINGS } from '../constants';

function BidClosedDateChecker({ closedDate, solId, bidId, setAlert }) {
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const isBidClosedDatePast = () => {
      const currentDate = new Date();
      
      // For bid closing check: extend to end of the minute
      const bidClosedDateExtended = new Date(closedDate);
      currentDate.setSeconds(59, 999);
      bidClosedDateExtended.setSeconds(59, 999); // Set to end of the minute

      // For alert timing: use original minute boundary
      const bidClosedDateOriginal = new Date(closedDate);
      bidClosedDateOriginal.setSeconds(0, 0);

      // Calculate time difference for closing check
      const timeDiffClosing = Math.floor((bidClosedDateExtended - currentDate) / (1000 * 60));
      
      // Calculate time difference for alert check (based on original time)
      const timeDiffAlert = Math.floor((bidClosedDateOriginal - currentDate) / (1000 * 60));

      if (timeDiffClosing < 0) {
        window.location.href = `/catalog/solicitations/${solId}/bid-dashboard/${bidId}`;
      } else if (
        timeDiffAlert < BID_CLOSE_MONITOR_SETTINGS.ALERT_THRESHOLD_MINUTES &&
        !showAlert
      ) {
        setShowAlert(true);
        setAlert({
          type: 'warning',
          message: `This bid will close in less than ${BID_CLOSE_MONITOR_SETTINGS.ALERT_THRESHOLD_MINUTES} minutes.`,
        });
      }
    };

    isBidClosedDatePast();

    const interval = setInterval(
      isBidClosedDatePast,
      BID_CLOSE_MONITOR_SETTINGS.CHECK_INTERVAL_MS,
    ); // Check every 10 seconds

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, [closedDate]);

  return null;
}

BidClosedDateChecker.propTypes = {
  closedDate: PropTypes.instanceOf(Date).isRequired,
  solId: PropTypes.number.isRequired,
  bidId: PropTypes.number.isRequired,
  setAlert: PropTypes.func.isRequired,
};

export default BidClosedDateChecker;